import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
//import { BottomNavigationMobile } from "../../navigationSection/BottomNavigationMobile";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";

//import HomeReusableTopBarNavigation from "../../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import {
  get_category_menu_setup,
  get_category_menu_setup_with_loader,
} from "../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { logOutUser } from "../../../../store/actions/authAction";
import OrderRequestBody from "./OrderRequestBody";
import { useDispatch } from "react-redux";
import {
  CLEAR_CART_DATA,
  SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
  CREATE_ORDER_VENDOR,
} from "../../../../store/types";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Media from "react-media";
import { BottomNavigationMobile } from "../../navigationSection/BottomNavigationMobile";

const OrderRequest = (props) => {
  const [state, setState] = useState({ selectedPage: 1, status: "All" });
  const dispatch = useDispatch();
  let history = useHistory();
  // const onPageChange = (value) => (e) => {
  //   setState({ ...state, selectedPage: value });
  // };

  useEffect(
    () => {
      const token = props.auth.user.accessToken;
      // if (props.menuCategory.length <= 0) {
      props.get_category_menu_setup_with_loader(token);
      // }
    },
    []
    // [window.location.pathname]
  );

  // useEffect(() => {
  //   dispatch({ type: CLEAR_CART_DATA });
  // }, []);

  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    setMenuData(props?.vendor_filtered_menu);
  }, [props?.vendor_filtered_menu]);

  useEffect(() => {
    if (history?.location?.state !== undefined) {
      dispatch({
        type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
        payload: history?.location?.state?.cartData,
      });
      dispatch({
        type: CREATE_ORDER_VENDOR,
        payload: history?.location?.state?.userData,
      });
    }
  }, [history?.location?.state !== undefined]);

  const [screen, setScreen] = useState(false);

  try {
    return (
      <React.Fragment>
        {/* {props?.menuCategory.length <= 0 ? ( */}
        {props.auth.menu_loader ? (
          <AmealioLoader />
        ) : (
          <React.Fragment>
            <Container fluid className="vendor-orders-request">
              <Row>
                <Media query="(min-width: 992px)">
                  <div className="left-side-panel">
                    <LeftSideNavigation />
                  </div>
                </Media>
                <div className="top-panel">
                  <TopNavigationBarMobile displayLeft="logo" />
                </div>
                <div className="right-side-panel">
                  <RightSideNavigation
                    titleCenter={
                      screen ? "Items added to cart" : "Ordering Request"
                    }
                  />
                  {/* {console.log(props.orderData, "***")} */}
                  {menuData && menuData ? (
                    <OrderRequestBody
                      setScreen={setScreen}
                      key={window.location.pathname}
                      data={menuData && menuData}
                      selectedTabId={
                        props &&
                        props.orderData &&
                        props.orderData.selectedTabId
                      }
                      orderSelected={
                        props &&
                        props.orderData &&
                        props.orderData.orderSelected
                      }
                    />
                  ) : (
                    <AmealioLoader />
                  )}
                  <br />
                </div>
                {/* <Media query="(max-width: 991px)">
                  <div className="bottom-panel">
                    <BottomNavigationMobile />
                  </div>
                </Media> */}
              </Row>
            </Container>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};

OrderRequest.propTypes = {
  logOutUser: PropTypes.func.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  get_category_menu_setup_with_loader: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  menuCategory: state.onboarding?.menuCategory,
  vendor_filtered_menu: state.vendorOrdering?.vendor_filtered_menu,
  orderData: state.vendorOrdering?.vendor_order_data,
});

export default connect(mapStateToProps, {
  logOutUser,
  get_category_menu_setup,
  get_category_menu_setup_with_loader,
})(withRouter(OrderRequest));
